import { onResize } from "@demant/wdh";

var languageSelectorActive = function languageSelectorActive() {
  var aTags = document.querySelectorAll(".language-selector-spot a");
  var frenchSelector = aTags[1];
  var germanSelector = aTags[0];

  if (window.location.href.indexOf("/fr") > -1) {
    frenchSelector.classList.add('active');
  } else {
    germanSelector.classList.add('active');
  }
};

var toggleMobileMenu = function toggleMobileMenu() {
  var isMobile = window.matchMedia('(max-width:767px)').matches;
  var button = document.querySelector(".button");

  if (button) {
    button.remove();
  }

  var header = document.querySelector(".header");
  header.classList.remove("open");

  if (isMobile) {
    var wrapper = document.querySelector(".wrapper");

    var _button = document.createElement("button");

    _button.classList.add("button");

    var div = document.createElement("div");
    wrapper.appendChild(_button);

    _button.appendChild(div);

    _button.addEventListener('click', function (event) {
      event.preventDefault();

      if (header.classList.contains("open")) {
        header.classList.remove("open");

        _button.classList.remove("open");
      } else {
        header.classList.add("open");

        _button.classList.add("open");
      }
    });
  } else {
    if (button) {
      button.remove();
    }
  }
};

onResize(function () {
  toggleMobileMenu();
});

(function () {
  languageSelectorActive();
  toggleMobileMenu();
})();